<script setup lang="ts">
import { totalGoalMarkets } from "~/utils/constants";
import t from "~/utils/translate";
import { useBetbook } from "~/store/betbook";
import { scrollIntoView } from "~/utils/scrollUtil";

const betbook = useBetbook();
const { $trackEvent } = useNuxtApp();
const isMarketActive = (marketName: string) => {
	return !!betbook.displayMarkets.find((x) => x.name === marketName);
};

const handleMarketChange = (val: { name: string; displayName: string; filterIndex: number } | string, index: number) => {
	if (typeof val !== "string") {
		const clone = [...betbook.displayMarkets];
		clone[index] = val;
		betbook.displayMarkets = clone;
		$trackEvent.toggleFixtureType(val.displayName);
		scrollIntoView();
	}
};
</script>

<template>
	<div class="flex gap-3 overflow-x-auto overflow-y-hidden scrollbar-hidden" id="sport-market-list-scroller">
		<div
			v-for="market in betbook.filters.markets"
			:key="market.name"
			class="text-sm font-semibold text-center transition-all border-b-2 cursor-pointer whitespace-nowrap"
			:class="isMarketActive(market.name) ? 'text-identity  border-b-identity sport-market-list-active' : 'border-b-[transparent]'"
			@click="
				() => {
					if (!isMarketActive(market.name)) handleMarketChange(market, 0);
				}
			"
		>
			<span class="min-w-[60px] block">
				{{ totalGoalMarkets[market.name] ? t("total-goals") : market.displayName }}
			</span>
		</div>
	</div>
</template>

<style scoped lang="scss"></style>
